module.exports = __webpack_public_path__ + "static/media/icon-character__josef-stalin.0bff7a87.svg";